import {MouseEvent} from "react";
import {useNavigationLoaderStore} from "../../model/navigationLoaderStore";

export const startNavigationLoader = () => {
    useNavigationLoaderStore.getState().setLoading(true);
};

export const stopNavigationLoader = () => {
    useNavigationLoaderStore.getState().setLoading(false);
};

export const isCurrentWindowNavigation = (event: MouseEvent<HTMLAnchorElement>) => {
    return (
        event.button === 0 &&
        !event.ctrlKey &&
        !event.metaKey &&
        !event.shiftKey &&
        !event.altKey
    );
}
